import { Row as AntdRow, Col as AntdCol } from 'antd';

const View = 'div';
const Row = AntdRow;
const Col = AntdCol;

Row.displayName = 'Row';
Col.displayName = 'Col';

export { View, Row, Col };
